import React, { useId } from 'react';

interface MoonPhasePhotoProps {
  dayInCycle: number;
  phaseName: string;
  className?: string;
  size?: number | string;
}

const SYNODIC_MONTH = 29.53059;

const MoonPhasePhoto: React.FC<MoonPhasePhotoProps> = ({
  dayInCycle,
  phaseName,
  className,
  size = '100%',
}) => {
  const clipId = `moon-disc-${useId().replace(/:/g, '')}`;
  const normalizedDay = ((dayInCycle % SYNODIC_MONTH) + SYNODIC_MONTH) % SYNODIC_MONTH;
  const shadowX = normalizedDay <= SYNODIC_MONTH / 2
    ? 50 - (normalizedDay / (SYNODIC_MONTH / 2)) * 100
    : 150 - ((normalizedDay - SYNODIC_MONTH / 2) / (SYNODIC_MONTH / 2)) * 100;

  return (
    <svg
      className={className}
      viewBox="0 0 100 100"
      role="img"
      aria-label={`${phaseName} Moon`}
      style={{ width: size, height: size }}
    >
      <defs>
        <clipPath id={clipId}><circle cx="50" cy="50" r="43" /></clipPath>
        <radialGradient id={`${clipId}-shade`} cx="35%" cy="30%">
          <stop offset="0%" stopColor="#090a10" stopOpacity=".93" />
          <stop offset="100%" stopColor="#020309" stopOpacity=".99" />
        </radialGradient>
      </defs>
      <circle cx="50" cy="50" r="44" fill="#05060b" />
      <image
        href={`${process.env.PUBLIC_URL}/planets/moon.jpg`}
        x="7"
        y="7"
        width="86"
        height="86"
        preserveAspectRatio="xMidYMid slice"
        clipPath={`url(#${clipId})`}
      />
      <circle
        cx={shadowX}
        cy="50"
        r="43.15"
        fill={`url(#${clipId}-shade)`}
        clipPath={`url(#${clipId})`}
      />
      <circle cx="50" cy="50" r="43" fill="none" stroke="rgba(255,255,255,.22)" strokeWidth=".7" />
    </svg>
  );
};

export default MoonPhasePhoto;
